var _ = require('lodash');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<p class="margin-bottom-ms-1"> На указанный вами e-mail есть учетная запись, в которой персональные данные не совпадают с данными вашего профиля Госуслуг. </p> <p class="margin-bottom-0"> Если на портале Госуслуг указаны верные данные, то вам необходимо войти в <a href="';
 myRgsUrl 
__p+='">Личный кабинет</a> по e-mail (если забыли пароль, то используйте соответствующую процедуру), перейти в "Мой профиль" и подать запрос на корректировку данных. </p>';
}
return __p;
};
